import { Injectable } from '@angular/core';
import { ActiconSceneLightComponent } from '../v3d-components/scene-light/scene-light';
import { acticonV3dComponentNames } from '../v3d-components/acticon-v3d-component-names';
import { ColorRepresentation, Vector3 } from 'three';

/**
 * Service for creating Acticon-specific Visualize3D components
 */
@Injectable({
  providedIn: 'root'
})
export class ActiconVisualize3dComponentProvider {
  /**
   * Generates the scene lighting component
   * @param lightPositions Positions for the lights, the direction of light for each model is the angle from the model center to the light
   * @param color Light color
   */
  public createSceneLightComponent(lightPositions: Vector3[], color: ColorRepresentation): ActiconSceneLightComponent {
    return {
      type: acticonV3dComponentNames.sceneLight,
      $type: acticonV3dComponentNames.sceneLight,
      directions: lightPositions,
      color: color
    };
  }
}
